import type { ServiceAreaRule, ServiceAreaSet } from './types'

export function normalizeServiceAreaValue(value: string, postal = false): string {
  const normalized = value.trim().toLocaleLowerCase().replace(/\s+/gu, ' ')
  return postal ? normalized.replace(/[\s-]+/gu, '') : normalized
}

export function serviceAreaRuleMatches(rule: ServiceAreaRule, input: string): boolean {
  const postal = rule.type === 'postal_exact' || rule.type === 'postal_prefix'
  const candidate = normalizeServiceAreaValue(input, postal)
  const expected = normalizeServiceAreaValue(rule.value, postal)

  if (!candidate || !expected) return false
  if (rule.type === 'postal_prefix') return candidate.startsWith(expected)

  return candidate === expected
}

export function matchesServiceArea(set: ServiceAreaSet, input: string): boolean {
  const matchingRules = set.rules.filter((rule) => serviceAreaRuleMatches(rule, input))
  if (matchingRules.some((rule) => rule.isExclusion)) return false
  if (set.mode === 'everywhere') return true

  return matchingRules.some((rule) => !rule.isExclusion)
}
